import type { User } from "~/types/oauth";
import { defineStore } from "pinia";
import type { LocationReference } from "~/types/api";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: null as User | null,
  }),
  actions: {
    setUser(user: User) {
      if (!user) {
        console.warn("Attempted to set null or undefined user");
        return;
      }
      this.user = { ...user };
    },
    setTimezone(timezone: string) {
      if (!this.user) {
        console.warn("Attempted to set null or undefined user");
        return;
      }
      this.user.timezone = timezone;
    },
  },
  getters: {
    getLocations(): LocationReference[] {
      return this.user?.profiles.map((profile) => profile.location) || [];
    },
    getTimezone(): string {
      return this.user?.timezone || "Europe/Amsterdam";
    },
  },
});
